import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

export default function useDeleteExtraction(callbacks: IRQCallbacks) {
  const glynt = useGlynt();
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (extractionId: string) => {
      return await (await glynt).extraction.del(extractionId);
    },

    ...callbacks,
    onMutate: async (extractionId) => {
      // Let's optimisitcally update the cache to remove the extraction batch

      // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
      await client.cancelQueries({
        queryKey: ['allExtractions']
      });

      const previousExtractions = client.getQueriesData({
        queryKey: ['allExtractions'],
      });

      client.setQueriesData({ queryKey: ['allExtractions'] }, (currentData: any) => {
        if (!currentData?.pages) {
          return currentData;
        }

        return {
          ...currentData,
          pages: currentData.pages.map((page: any) => ({
            ...page,
            results: page.results.filter((result: any) => result.id !== extractionId),
          })),
        };
      });

      // Return a context object with the snapshotted value
      return { previousExtractions };
    },
  });
}
